module.exports = __webpack_public_path__ + "img/pr-2.07604811.png";